export function initFile() {
    const forms = document.querySelectorAll<HTMLDivElement>('.form-file');
    console.log(forms)
    forms.forEach(formFile => {
        const formFilesContainer = formFile.closest<HTMLDivElement>('.form-files')!;
        const iconButton = formFile.querySelector<HTMLButtonElement>('.form-file__icon');
        const formFiles = formFile.querySelectorAll<HTMLInputElement>('.form-file__input');
        console.log(formFilesContainer)
        if (!formFilesContainer) return;

        // Открытие / закрытие
        iconButton?.addEventListener('click', (e) => {
            e.stopPropagation();
            formFile.classList.toggle('active');
        });

        // Закрытие при клике вне текущей формы
        document.addEventListener('click', (e) => {
            if (!formFile.contains(e.target as Node)) {
                formFile.classList.remove('active');
            }
        });

        // Загрузка файлов
        formFiles.forEach(input => {
            input.addEventListener('change', (e) => handleFileUpload(e, formFile, formFilesContainer));
        });
    });

    function handleFileUpload(
        event: Event,
        formFile: HTMLDivElement,
        container: HTMLDivElement
    ) {
        const target = event.target as HTMLInputElement;
        if (!target.files) return;

        const fileType = target.dataset.type ?? '';

        formFile.classList.remove('active');

        Array.from(target.files).forEach(file => {
            const fileItem = createFileItem(file, fileType);
            container.appendChild(fileItem);

            const spinner = fileItem.querySelector<HTMLDivElement>('.spinner');
            if (spinner) simulateFileUpload(spinner);
        });

        // сброс value, чтобы можно было загрузить тот же файл повторно
        target.value = '';
    }

    function createFileItem(file: File, type: string): HTMLDivElement {
        const fileItem = document.createElement('div');
        fileItem.className = 'file-item size-16';

        const filePic = document.createElement('div');
        filePic.className = 'file-item__pic';

        const spinner = document.createElement('div');
        spinner.className = 'spinner';
        filePic.appendChild(spinner);

        const fileTitle = document.createElement('div');
        fileTitle.className = 'file-item__title';
        fileTitle.textContent = file.name;

        const deleteBtn = document.createElement('button');
        deleteBtn.className = 'file-item__delete icon';
        deleteBtn.innerHTML = `
            <svg>
                <use xlink:href="images/sprite.svg#icon-close"></use>
            </svg>
        `;
        deleteBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            fileItem.remove();
        });

        if (type === 'image') {
            const img = document.createElement('img');
            const reader = new FileReader();
            reader.onload = () => {
                img.src = reader.result as string;
                filePic.appendChild(img);
            };
            reader.readAsDataURL(file);
        }

        if (type === 'video') {
            const video = document.createElement('video');
            video.src = URL.createObjectURL(file);
            video.onloadeddata = () => {
                video.currentTime = 0;
                video.pause();
                filePic.appendChild(video);
            };
        }

        fileItem.append(filePic, fileTitle, deleteBtn);
        return fileItem;
    }

    function simulateFileUpload(spinner: HTMLDivElement) {
        setTimeout(() => {
            spinner.style.borderTopColor = 'green';
            setTimeout(() => spinner.remove(), 500);
        }, 3000);
    }
}
